interface IButton {
  btnText: string;
  onClick?: () => void;
  fullWidth?: boolean;
  disabled?: boolean;
}
export const Button = ({
  btnText,
  onClick,
  fullWidth,
  disabled,
  ...props
}: IButton) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={` ${
        disabled ? "bg-blue-200" : "bg-pc-blue"
      } text-white rounded-lg py-2 px-2 my-3 text-center ${
        fullWidth && "w-full"
      }`}
    >
      {btnText}
    </button>
  );
};
